import { createContext, useContextSelectors } from "@-/com.npmjs.use-context-selectors";

export const ActorSyncPreparingContext = createContext(false);

/** Whether the signed-in actor database is still opening and pulling the user's data. */
export function useIsActorSyncPreparing(): boolean {
  const [isActorSyncPreparing] = useContextSelectors(
    ActorSyncPreparingContext,
    (isPreparing) => isPreparing,
  );
  return isActorSyncPreparing;
}
